import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { BuyerFiltering, BuyerAddEdit } from './Pages';

export const BuyerRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={BuyerFiltering} />
        <Route exact path={`${match.path}/AddEdit`} component={BuyerAddEdit} />
    </Fragment>
)